const translation = {
  nav_used_pallets: "Gebrauchte Paletten",
  nav_new_pallets: "Neue Paletten",
  nav_services: "Dienstleistungen",
  nav_about: "Über uns",
  nav_faq: "FAQ",
  nav_contact: "Kontakt",
  nav_get_quote: "Angebot",

  hero_location: "Antwerpen, Belgien",
  hero_title_line1: "PREMIUM",
  hero_title_line2: "EURO-PALETTEN",
  hero_subtitle: "Zuverlässiger Lieferant von Klasse A, Klasse B Gebrauchtpaletten & neuen Holzpaletten. Qualitätsgeprüft. Schnelle Lieferung in ganz Belgien.",
  hero_cta_quote: "Angebot anfordern",
  hero_cta_products: "Produkte ansehen",

  stat_years: "Jahre Erfahrung",
  stat_pallets: "Gelieferte Paletten",
  stat_grades: "Produktklassen",
  stat_quality: "Qualitätsgeprüft",

  gallery_label: "Qualität, die man sieht",
  gallery_title: "Unsere Palettenkollektion",
  gallery_grade_a: "Klasse A Premium",
  gallery_grade_b: "Klasse B Wert",
  gallery_new: "Neue Paletten",
  gallery_custom: "Sonderbestellungen",

  how_label: "Einfacher Prozess",
  how_title: "So funktioniert es",
  how_subtitle: "Vom Stöbern bis zur Lieferung machen wir die Palettenbestellung schnell und unkompliziert.",
  how_step1_title: "Durchsuchen & Auswählen",
  how_step1_desc: "Entdecken Sie unser Sortiment an Klasse A, Klasse B und neuen Holzpaletten. Sehen Sie detaillierte Spezifikationen und Fotos.",
  how_step2_title: "Angebot / Bestellung",
  how_step2_desc: "Senden Sie eine Angebotsanfrage oder geben Sie direkt online eine Bestellung auf. Wir bestätigen innerhalb von 24 Stunden.",
  how_step3_title: "Schnelle Lieferung",
  how_step3_desc: "Erhalten Sie Ihre Paletten schnell in ganz Belgien und Europa. Alle Bestellungen werden vor dem Versand qualitätsgeprüft.",

  used_label: "Qualitätsgebrauchte Paletten",
  used_title: "Gebrauchte Euro-Paletten",
  used_subtitle: "Wählen Sie zwischen Klasse A Premium oder Klasse B kostengünstigen Paletten. Alle geprüft und sofort einsatzbereit.",

  new_label: "Brandneue Paletten",
  new_title: "Neue Holzpaletten",
  new_subtitle: "ISPM15-zertifizierte, exportfertige Paletten nach höchsten Standards. Sondergrößen verfügbar.",

  pricing_label: "Transparente Preise",
  pricing_title: "Mengenpreis-Staffeln",
  pricing_subtitle: "Wettbewerbsfähige Preise mit Mengenrabatten. Je mehr Sie bestellen, desto mehr sparen Sie.",
  pricing_grade_a: "Klasse A Paletten",
  pricing_grade_b: "Klasse B Paletten",
  pricing_new: "Neue Paletten",
  pricing_tier_1: "10-100 Stück",
  pricing_tier_2: "100-500 Stück",
  pricing_tier_3: "500-5000 Stück", 
  pricing_tier_4: "5000+ Stück",
  pricing_per_pallet: "pro Palette",
  pricing_contact: "Kontaktieren Sie uns für individuelle Preise bei größeren Mengen",

  product_quick_specs: "Kurzspezifikationen",
  product_dimensions: "Abmessungen",
  product_load: "Tragfähigkeit",
  product_wood: "Holzart",
  product_order_now: "Jetzt bestellen",
  product_view_details: "Details ansehen",
  product_view_angles: "Ansichten & Details",
  product_tech_specs: "Technische Spezifikationen",
  product_key_features: "Hauptmerkmale",
  product_request_quote: "Angebot für dieses Produkt anfordern",
  product_call_us: "Anrufen",
  product_pricing_tiers: "Mengenpreise",
  product_quantity: "Menge",
  product_price_per_pallet: "Preis pro Palette",
  product_total_price: "Gesamtpreis",
  product_current_tier: "Aktuelle Preisstufe",

  calc_current_price: "Aktueller Preis",
  calc_volume_hint: "Mengenpreise verfügbar – mehr bestellen, mehr sparen!",
  calc_total_price: "Gesamtpreis",
  calc_price_per: "Preis pro Palette",
  calc_quantity: "Menge",
  calc_pallets: "Paletten",
  calc_order_now: "Bestellen",
  calc_current_selection: "Aktuelle Auswahl",
  calc_pieces: "Stück",
  calc_per_pallet: "pro Palette",
  calc_calculate: "Bestellung berechnen",
  calc_payment_methods: "VERFÜGBARE ZAHLUNGSMETHODEN",
  calc_volume_pricing: "Mengenpreise",
  calc_bulk_discount: "Mengenrabatt angewendet",
  calc_min_order: "Mindestbestellung: 10 Paletten",
  calc_payment_methods_label: "Zahlungsmethoden:",
  calc_total: "Gesamt:",
  calc_select_qty: "Menge & Zahlung auswählen",
  calc_total_price_label: "Gesamtpreis",

  services_label: "Was wir tun",
  services_title: "Unsere Dienstleistungen",
  services_subtitle: "Von der Sortierung bis zur Lieferung bieten wir komplette Palettenlösungen für Ihr Unternehmen.",
  service1_title: "Palettensortierung & -klassifizierung",
  service1_desc: "Fachkundige manuelle Inspektion und Klassifizierung jeder Palette.",
  service2_title: "Großmengenlieferung",
  service2_desc: "Großbestellungen willkommen. Wettbewerbsfähige Preise für Großeinkäufe.",
  service3_title: "Sonderbestellungen",
  service3_desc: "Benötigen Sie nicht standardmäßige Größen? Wir fertigen individuelle Holzpaletten.",
  service4_title: "Schnelle Lieferung",
  service4_desc: "Zuverlässige Lieferung in ganz Belgien und Europa.",

  quality_label: "Unsere Standards",
  quality_title: "Qualitätsklassensystem",
  quality_subtitle: "Jede Palette wird sorgfältig nach strengen europäischen Standards geprüft und klassifiziert.",
  grade_a_label: "Premium-Klasse",
  grade_b_label: "Standardklasse",
  grade_new_label: "Brandneu",

  about_label: "Wer wir sind",
  about_title: "Antwerpens vertrauenswürdiger Palettenpartner",
  about_p1: "PEL Partner Company ist ein spezialisierter Euro-Palettenlieferant mit Sitz in Antwerpen, Belgien. Wir versorgen Unternehmen in ganz Belgien und Europa mit hochwertigen Paletten.",
  about_p2: "Ob Sie Premium-Klasse-A-Paletten, kostengünstige Klasse-B oder brandneue Exportpaletten benötigen — wir haben die richtige Lösung zum richtigen Preis.",
  about_location: "Antwerpen, Belgien",
  about_quality: "Jede Palette geprüft",
  about_delivery: "Schnell in ganz Belgien",
  about_support: "Mo–Fr 8:00–18:00",
  about_years: "Jahre im Geschäft",
  about_supplied: "Gelieferte Paletten",

  videos_label: "Sehen Sie es in Aktion",
  videos_title: "Unsere Abläufe",
  videos_subtitle: "Sehen Sie, wie wir Paletten sortieren, prüfen und vorbereiten.",
  tab_sorting: "Sortierprozess",
  tab_quality: "Qualitätsprüfung",
  tab_delivery: "Lieferung",
  video_sorting_title: "Manuelle Sortierung & Inspektion",
  video_sorting_desc: "Jede Palette wird manuell auf Qualität geprüft",
  video_strict: "Strenge Inspektion",
  video_strict_desc: "Jede Palette wird manuell auf strukturelle Integrität und EPAL-Konformität geprüft.",
  video_sorted: "Nach Klasse sortiert",
  video_sorted_desc: "Paletten werden sorgfältig in Klasse A, B und Neu sortiert.",
  video_reliable: "Zuverlässige Lieferung",
  video_reliable_desc: "Wir liefern in ganz Antwerpen und Belgien mit schnellen Durchlaufzeiten.",

  why_title: "Warum PEL Partner wählen?",
  why1_title: "Zertifizierte Qualität",
  why1_desc: "EPAL-zertifizierte Paletten, jede Charge nach europäischen Standards geprüft.",
  why2_title: "Wettbewerbsfähige Preise",
  why2_desc: "Beste Preise in Antwerpen für Klasse A, B und neue Paletten.",
  why3_title: "Schnelle Abwicklung",
  why3_desc: "Schnelle Auftragsbearbeitung und Lieferung in ganz Belgien.",
  why4_title: "Zuverlässiger Partner",
  why4_desc: "Langfristige Beziehungen auf Basis von Vertrauen und Qualität.",

  delivery_label: "Wir liefern in ganz Belgien",
  delivery_title: "Unsere Servicegebiete",
  delivery_subtitle: "Schnelle und zuverlässige Palettenlieferung in alle wichtigen Städte Belgiens und Europas.",

  faq_label: "Häufige Fragen",
  faq_title: "Häufig gestellte Fragen",
  faq_subtitle: "Finden Sie Antworten auf die häufigsten Fragen zu unseren Paletten, Dienstleistungen und dem Bestellprozess.",
  faq_q1: "Welche Palettenklassen bieten Sie an?",
  faq_a1: "Wir bieten drei Klassen an: Klasse A (Premium-Gebrauchtpaletten in ausgezeichnetem Zustand), Klasse B (kostengünstige Gebrauchtpaletten mit leichten Gebrauchsspuren) und neue Holzpaletten (brandneu, ISPM15-zertifiziert für den Export).",
  faq_q2: "Wie sehen Ihre aktuellen Preisstufen aus?",
  faq_a2: "Klasse A: 12€ (10-100), 10€ (100-500), 8,5€ (500-5000), 7,5€ (5000+). Klasse B: 10€ (10-100), 8€ (100-500), 7€ (500-5000), 6€ (5000+). Neue Paletten: 20€ (10-100), 15€ (100-500), 12€ (500-5000), 10€ (5000+). Alle Preise pro Palette mit Mengenrabatten verfügbar.",
  faq_q3: "Was ist die Mindestbestellmenge?",
  faq_a3: "Wir bearbeiten Bestellungen ab 10 Paletten, mit Mengenstaffelpreisen für bessere Konditionen bei größeren Mengen. Kontaktieren Sie uns für Ihre spezifischen Anforderungen.",
  faq_q4: "In welche Gebiete liefern Sie?",
  faq_a4: "Wir liefern in ganz Belgien, einschließlich Antwerpen, Brüssel, Gent, Brügge und Lüttich. Wir beliefern auch Kunden in ganz Europa.",
  faq_q5: "Wie sind Ihre Lieferzeiten?",
  faq_a5: "Klasse A und B Gebrauchtpaletten sind in der Regel auf Lager und sofort lieferbar. Neue Holzpaletten können je nach Menge 1-2 Wochen benötigen.",
  faq_q6: "Sind Ihre Paletten EPAL-zertifiziert?",
  faq_a6: "Ja, unsere Klasse-A-Paletten sind EPAL-zertifiziert und gestempelt. Alle neuen Holzpaletten sind ISPM15-wärmebehandelt und gestempelt.",
  faq_q7: "Bieten Sie individuelle Palettengrößen an?",
  faq_a7: "Ja, wir können neue Holzpaletten in individuellen Abmessungen fertigen. Standardgröße EUR/EPAL ist 1200 × 800 mm.",
  faq_q8: "Wie stellen Sie die Palettenqualität sicher?",
  faq_a8: "Jede Palette wird von unserem geschulten Personal manuell geprüft. Wir kontrollieren strukturelle Integrität und EPAL-Konformität.",
  faq_q9: "Welche Zahlungsmethoden akzeptieren Sie?",
  faq_a9: "Wir akzeptieren Banküberweisungen, Kreditkarten und können Zahlungskonditionen für Stammkunden vereinbaren.",

  contact_label: "Kontakt aufnehmen",
  contact_title: "Kontaktieren Sie uns",
  contact_info_title: "Kontaktinformationen",
  contact_phone_label: "Telefon",
  contact_email_label: "E-Mail",
  contact_location_label: "Standort",
  contact_hours_label: "Geschäftszeiten",
  contact_hours_val: "Montag – Freitag: 8:00 – 18:00",
  contact_call_now: "Jetzt anrufen",
  contact_email_us: "E-Mail senden",
  contact_quote_title: "Angebot anfordern",
  form_name: "Name",
  form_phone: "Telefon",
  form_email: "E-Mail",
  form_product: "Produkt",
  form_product_placeholder: "Produkt auswählen...",
  form_product_a: "Gebrauchte Euro-Paletten — Klasse A",
  form_product_b: "Gebrauchte Euro-Paletten — Klasse B",
  form_product_new: "Neue Holzpaletten",
  form_product_mixed: "Gemischte Bestellung",
  form_message: "Nachricht",
  form_message_placeholder: "Teilen Sie uns Ihre Anforderungen mit...",
  form_send: "Anfrage senden",
  form_sending: "Wird gesendet...",
  form_success_title: "Nachricht gesendet!",
  form_success_desc: "Wir melden uns so schnell wie möglich bei Ihnen.",
  form_send_another: "Weitere senden",
  form_error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",

  order_title: "Bestellung aufgeben",
  order_subtitle: "Füllen Sie Ihre Daten aus und wir bestätigen Ihre Bestellung innerhalb von 24 Stunden.",
  order_company: "Firmenname",
  order_company_ph: "Ihr Firmenname",
  order_contact: "Kontaktname",
  order_contact_ph: "Ihr vollständiger Name",
  order_quantity: "Menge",
  order_quantity_ph: "Anzahl der Paletten",
  order_address: "Lieferadresse",
  order_address_ph: "Straße, Stadt, Postleitzahl",
  order_date: "Gewünschtes Lieferdatum",
  order_notes: "Zusätzliche Hinweise",
  order_notes_ph: "Besondere Anforderungen oder Fragen...",
  order_cancel: "Abbrechen",
  order_review: "Bestellung prüfen",
  order_summary_title: "Bestellübersicht",
  order_summary_subtitle: "Bitte überprüfen Sie Ihre Bestelldetails vor dem Absenden.",
  order_company_info: "Unternehmensinformationen",
  order_company_name_label: "Firmenname",
  order_contact_label: "Ansprechpartner",
  order_email_label: "E-Mail",
  order_phone_label: "Telefon",
  order_details: "Bestelldetails",
  order_product_label: "Produkt",
  order_qty_label: "Menge",
  order_qty_unit: "Paletten",
  order_address_label: "Lieferadresse",
  order_date_label: "Gewünschtes Datum",
  order_notes_label: "Zusätzliche Hinweise",
  order_next_steps: "Nächste Schritte:",
  order_next_steps_desc: "Nach dem Absenden prüft unser Team Ihre Bestellung und kontaktiert Sie innerhalb von 24 Stunden.",
  order_edit: "Bestellung bearbeiten",
  order_confirm: "Bestätigen & Absenden",
  order_submitting: "Bestellung wird übermittelt...",
  order_submitting_desc: "Bitte warten Sie einen Moment.",
  order_success_title: "Bestellung erfolgreich übermittelt!",
  order_ref_label: "Referenznummer",
  order_success_desc: "Vielen Dank für Ihre Bestellung! Wir werden Ihre Anfrage prüfen und Sie innerhalb von 24 Stunden kontaktieren.",
  order_close: "Schließen",
  order_error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",

  footer_products: "Produkte",
  footer_contact: "Kontakt",
  footer_copyright: "© 2025 PEL Partner Company. Alle Rechte vorbehalten.",
  footer_tagline: "Antwerpen, Belgien — Euro-Palettenlieferant",
  footer_desc: "Ihr vertrauenswürdiger Euro-Palettenlieferant in Antwerpen, Belgien. Klasse A, B und neue Holzpaletten — Qualität garantiert.",

  compare_label: "Vergleich",
  compare_title: "Unsere Palettenklassen im Vergleich",
  compare_subtitle: "Nicht sicher, welche Klasse die richtige ist? Vergleichen Sie alle drei Optionen auf einen Blick.",
  compare_feature: "Merkmal",
  compare_grade_a: "Klasse A",
  compare_grade_b: "Klasse B",
  compare_new: "Neue Paletten",
  compare_condition: "Zustand",
  compare_condition_a: "Ausgezeichnet — minimaler Verschleiß",
  compare_condition_b: "Gut — leichte kosmetische Abnutzung",
  compare_condition_new: "Brandneu — unbenutzt",
  compare_certification: "Zertifizierung",
  compare_certification_a: "EPAL-zertifiziert",
  compare_certification_b: "Qualitätsgeprüft",
  compare_certification_new: "ISPM15-zertifiziert",
  compare_load: "Tragfähigkeit",
  compare_load_a: "Bis zu 1500 kg",
  compare_load_b: "Bis zu 1000 kg",
  compare_load_new: "Bis zu 2000 kg",
  compare_export: "Exportbereit",
  compare_export_a: "Nur EU",
  compare_export_b: "Nur EU",
  compare_export_new: "Weltweit",
  compare_custom: "Sondergrößen",
  compare_custom_a: "Nein",
  compare_custom_b: "Nein",
  compare_custom_new: "Ja",
  compare_availability: "Verfügbarkeit",
  compare_availability_a: "Auf Lager",
  compare_availability_b: "Auf Lager",
  compare_availability_new: "Auf Bestellung",
  compare_best_for: "Am besten für",
  compare_best_for_a: "Lebensmittel, empfindliche Waren",
  compare_best_for_b: "Allgemeine Lagerung",
  compare_best_for_new: "Export & internationaler Versand",
  compare_starting_price: "Ab Preis",
  compare_cta: "Jetzt bestellen",
  compare_yes: "Ja",
  compare_no: "Nein",
};

export default translation;